import React from 'react'
import { CgProfile } from 'react-icons/cg'
import { IoLogOut, IoSettings } from 'react-icons/io5'
import { FaExternalLinkAlt } from 'react-icons/fa'
import { useDispatch } from 'react-redux'
import { MVPDropdownLink } from '../../Link/MVPDropdownLink'
import { clearActiveUser } from '../../../state/reducers/activeUser'
import ContextMenu from '../../ContextMenu/ContextMenu'
import SettingsModal from '../../modals/SettingsModal/SettingsModal'
import ProfileModal from '../../modals/ProfileModal/ProfileModal'
import ReferralModal from '../../modals/ReferralModal/ReferralModal'

export default () =>
{
	const dispatch = useDispatch()

	const handleClickLogout = () => {
		dispatch(clearActiveUser())
	}

	const clickReferrals = () => {
		ReferralModal.Show()
	}

	const handleClickProfile = () => {
		ProfileModal.Show()
	}

	const handleClickSettings = () => {
		SettingsModal.Show()
	}

	return (
		<ContextMenu alignment='center'>
			<MVPDropdownLink onClick={handleClickProfile}>
				<CgProfile />
				&nbsp;&nbsp;PROFILE
			</MVPDropdownLink>
			<MVPDropdownLink onClick={clickReferrals}>
				<FaExternalLinkAlt />
				&nbsp;&nbsp;REFERRALS
			</MVPDropdownLink>
			<MVPDropdownLink onClick={handleClickSettings}>
				<IoSettings />
				&nbsp;&nbsp;SETTINGS
			</MVPDropdownLink>
			<MVPDropdownLink onClick={handleClickLogout}>
				<IoLogOut />
				&nbsp;&nbsp;LOGOUT
			</MVPDropdownLink>
		</ContextMenu>
	)
}
